import {ServiceCategory} from "@/ui/service-block/ServiceBlock";

export const GENERAL_SERVICE_TERM_1 = "Excavation";
export const GENERAL_SERVICE_TERM_2 = "Excavation";
export const GENERAL_SERVICE_TERM_3 = "Excavation Services";

export const serviceBlockData : ServiceCategory[] = [
    {
        title: "Residential Excavation & Site Preparation",
        services: [
            "Backyard Excavation Services Sydney",
            "Driveway & Pathway Preparation Sydney",
            "Pool Removal & Garden Excavation Sydney",
            "House Extension & Renovation Excavation Sydney",
            "Tight Access Excavation Experts Sydney",
            "Soil Removal & Clean Fill Services Sydney",
            "Residential Trenching & Service Lines Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-1.jpg",
    },
    {
        title: "Commercial & Industrial Groundworks",
        services: [
            "Basement Excavation Contractors Sydney",
            "Bulk Earthmoving & Rock Removal Sydney",
            "Industrial Foundation Excavation Sydney",
            "Site Levelling & Commercial Benching Sydney",
            "Car Park & Road Excavation Sydney",
            "Commercial Trenching & Pipelaying Sydney",
            "Excavation for Factories & Warehouses Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-2.jpg",
    },
    {
        title: "Specialised Excavation & Equipment Hire",
        services: [
            "Posi Track Loader Hire Sydney",
            "Mini Digger & Excavator Hire Sydney",
            "Under-House Excavation Sydney",
            "Rock Breaking & Hard Ground Excavation Sydney",
            "Drainage & Stormwater Excavation Sydney",
            "Footing Excavation Specialists Sydney",
            "Custom Excavation Solutions Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-3.jpg",
    }
]





